import { FC } from 'react';

import Header, { HeaderProps } from 'features/Onboarding/components/Header';

import locales from './locales';

interface MandateeHeaderProps {
  legalName: string;
}

const MandateeHeader: FC<
  MandateeHeaderProps & Pick<HeaderProps, 'linkUrl' | 'linkText' | 'linkIcon'>
> = ({ legalName, ...props }) => (
  <Header
    description={locales.formatString(locales.description, {
      companyName: legalName,
    })}
    title={locales.formatString(locales.title, {
      companyName: legalName,
    })}
    {...props}
  />
);

export default MandateeHeader;
